import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/services/api/order.service';
import { WinService } from 'src/app/services/win.service';

@Component({
	selector: 'app-payment-generic',
	templateUrl: './payment-generic.component.html',
	styleUrls: ['./payment-generic.component.scss']
})
export class PaymentGenericComponent implements OnInit {

	order:any = null;
	orderIncrementId:any = null;
	dragonpayProcessors:any = null;

	selectedProcId:any = '';
	selectedDragonpayProcessor:any = null;

	payment_method: string = '';

	constructor(
		public activeRoute: ActivatedRoute,
		public winService: WinService,
		public orderService: OrderService
	) { }

	ngOnInit(): void {
		this.activeRoute.paramMap.subscribe( urlParam => {
			this.orderIncrementId = urlParam.get('orderIncrementId') + '';

			this.orderService.setLoader(true);
			this.orderService.getByIncrementId(this.orderIncrementId).then(order => {
				if(order){
					this.order = order;
					this.payment_method = this.order.payment.method;
					
					this.getDragonpayProc(this.order.base_grand_total).then((procs:any) => {

						let ai = this.order.payment.additional_information;
						ai.forEach(val => {
							if(val.indexOf('dragonpay_via_') == 0){
								this.selectedProcId = val.replace('dragonpay_via_', '');
								procs.forEach(proc => {
									if(proc.procId == this.selectedProcId){
										this.selectedDragonpayProcessor = proc;
									}
								});
							}
						});
						
						this.orderService.setLoader(false);
					});
				} else {
					this.order = {};
				}
			});
		});
	}

	get amountText(){
		return this.order.subtotal - this.order.discount_amount + this.order.shipping_amount + '';
	}

	get paymayaFee() {
		let subtotal = this.order.subtotal - this.order.discount_amount + this.order.shipping_amount;
        subtotal = this.order.base_grand_total - subtotal;

		return subtotal;
	}

	/**
	 * get the dragonpay's available processors depending on
	 * total ammount of the order
	 */
	 getDragonpayProc(ammount:any = 0){
		return new Promise(procs => {
			let url = this.orderService.getStoreUrl('/V1/lns-dragonpay/available/processors?ammount=' + ammount);
			this.orderService.doRequest(url, '', 'GET', true, false).then((result:any) => {
				if(!result.error && result.result){
					this.dragonpayProcessors = result.result;
					procs(this.dragonpayProcessors);
				}
			});
		});
	};

	setPaymaya(){
		this.payment_method = 'paymaya';
		this.selectedProcId = '';
		this.selectedDragonpayProcessor = null;
		this.reCalculateHandlingFeeRequest();
	}

	/**
	 * set payment method to dragonpay
	 */
	setDragonpayProcessor(proc){
		this.payment_method = 'dragonpay';
		this.selectedProcId = proc.procId;
		this.selectedDragonpayProcessor = proc;
		this.reCalculateHandlingFeeRequest();
	}

	reCalculateHandlingFeeRequest(){
		return new Promise(res => {
			let url = this.orderService.getStoreUrl('/V1/hnd-order/orders/handling-fee');
			let jsonData = {
				"order_id": this.order.entity_id,
				"new_payment_method": this.payment_method
			}

			if(this.selectedProcId){
				jsonData['procid'] = this.selectedProcId
			}

			this.orderService.setLoader(true);
			this.orderService.doRequest(url, jsonData, 'POST', true, false, {
				"Content-Type": 'application/json'
			}).then((result:any) => {
				if(!result.error && result.result){
					let o:any = result.result[0];

					this.order.base_grand_total = o['order']['base_grand_total'];
					this.order.grand_total = o['order']['grand_total'];
					this.order.total_due = o['order']['total_due'];
					this.order.base_total_due = o['order']['base_total_due'];
		
					this.order.payment.additional_information = o['payment']['additional_information'];
					this.order.payment.amount_ordered = o['payment']['amount_ordered'];
					this.order.payment.base_amount_ordered = o['payment']['base_amount_ordered'];
					this.order.payment.method = o['payment']['method'];
					res(o);
				} else {
					res(null);
				}
				this.orderService.setLoader(false);
			});
		});
	}

	payNow(){
		if(this.canDoPayment){
			if(this.payment_method == 'paymaya'){
				this.continueToPayMaya();
			}
			else if(this.payment_method = 'dragonpay'){
				this.goToDragonPay();
			}
		}
	}

	continueToPayMaya(){
		this.orderService.setLoader(true);
		let url = this.orderService.getStoreUrl('/V1/lns-payments/paymaya/'+this.order.entity_id);

		this.orderService.doRequest(url, '', 'GET', true, false).then((result:any) => {
			if(!result.error && result.result){
				window.location.href = result.result[0].redirectUrl;
			} else {
				this.orderService.setLoader(false);
				this.orderService.toastService.add('Failed to get the PayMaya link, please try again', 'danger');
			}
		});
	}

	/**
	 * redirect the site in the dragonpay dashboard
	 * @param orderId 
	 */
	goToDragonPay(){
		if(this.selectedProcId){
			let url = '/V2/lns-dragonpay/order/token/' + this.order.entity_id + '/' + this.selectedProcId + '?';
			url = this.orderService.getStoreUrl(url);

			this.orderService.setLoader(true);
			this.orderService.doRequest(url, '', 'GET', true, false).then((result:any) => {
				window.location.href = result.Url;
				this.orderService.setLoader(false);
			});
		} else {
			this.orderService.toastService.add('Please select Dragonpay payment processor', 'danger');
		}

		// let url = this.orderService.getStoreUrl('/V1/lns-dragonpay/order/token/' + this.order.entity_id);
		// if(this.selectedProcId){
		// 	url += '?procid=' + this.selectedProcId;
		// 	this.orderService.setLoader(true);
		// 	this.orderService.doRequest(url, '', 'GET', true, false).then((result:any) => {
		// 		if(!result.error && result.result){
		// 			window.location.href = result.result.link;
		// 		} else {
		// 			this.orderService.setLoader(false);
		// 			this.orderService.toastService.add('Failed to get the Dragonpay link, please try again', 'danger');
		// 		}
		// 	});
		// } else {
		// 	this.orderService.toastService.add('Please select Dragonpay payment processor', 'danger');
		// }
	}

	get canDoPayment() {
		let canPay:boolean = false;
		// if(this.order.status == 'waiting_for_payment' || this.order.status == 'payment_verification'){
		if(this.order.status == 'waiting_for_payment'){
			canPay = true;
		}
		return canPay;
	}
}